/**
 * Query scope for the Coverage pill's Insurance tab (BAR-3098): insurance patients in Financing &
 * approval, narrowed by Insurer, Step, Location and Status.
 */

import { PATIENT_FILTER_TAG_SYSTEMS, PAYMENT_STATUS_TAG_SYSTEMS, Track } from '@bariendo/lib/constants';
import { Meta } from '@medplum/fhirtypes';
import { buildCoverageFilter, tagCodes } from './coverageFilters';
import { QUEUE_FILTER_ANY, QueueFilterValues } from './queueFilters';
import { isOpenCase } from './readyToScheduleScope';

/** Insurer: `payor` holds the insurer's Organization id, read off 1.1's `payor` tag. */
export function buildInsuranceFilter(values: QueueFilterValues): string {
  const payor =
    values.payor === QUEUE_FILTER_ANY ? [] : [`_tag eq "${PAYMENT_STATUS_TAG_SYSTEMS.payor}|${values.payor}"`];
  return buildCoverageFilter([Track.INSURANCE], payor, values);
}

/** For rows that arrive by subscription: the insurance track and the chosen insurer. */
export function matchesInsuranceTab(patient: { meta?: Meta } | undefined, values: QueueFilterValues): boolean {
  if (!tagCodes(patient, PATIENT_FILTER_TAG_SYSTEMS.track).includes(Track.INSURANCE) || !isOpenCase(patient)) {
    return false;
  }
  return (
    values.payor === QUEUE_FILTER_ANY || tagCodes(patient, PAYMENT_STATUS_TAG_SYSTEMS.payor).includes(values.payor)
  );
}
